import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Space, Checkbox } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "@/assets//UserContext";
import axiosInstance from "@/axios/axiosInstance";
import "./login.scss";
const Logon = ({ logonType }) => {
  const [form] = Form.useForm();
  const { loginUser } = useUser();
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate(); // 获取 navigate 函数
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  useEffect(() => {
    // 当 logonType 发生变化时，清空表单字段
    form.resetFields();
  }, [form, logonType]); // 依赖项数组中包含 form 和 logonType
  const handleFinish = (values) => {
    if (!agreeToTerms) {
      message.warning("请阅读并同意用户协议和隐私政策");
      return;
    }
    let param = {
      ...values,
      type: logonType == 1 ? "PHONE_CODE" : "PASSWORD",
    };
    axiosInstance
      .post(`/account/login`, param)
      .then((response) => {
        if (response.data.code === 10000) {
          sessionStorage.setItem("token", response.data.data.token);
          loginUser(response.data.data);
          navigate("/personal");
        } else {
          message.error(response.data.msg); // 使用 message.error 显示错误信息
        }
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.msg) {
          message.error(error.response.data.msg); // 使用 message.error 显示错误信息
        } else {
          message.error("登录失败，请稍后再试"); // 默认错误信息
        }
      });
  };
  const handleGetCode = async () => {
    // 验证手机号是否正确
    try {
      await form.validateFields(["username"]);
      const phone = form.getFieldValue("username"); // 获取手机号
      setSendButtonDisabled(true); // 禁用按钮开始倒计时
      setCountdown(60);
      // 这里怎么调用接口设置 pCode
      axiosInstance
        .get(`/account/sendVerifyCode?phone=${phone}`)
        .then((response) => {})
        .catch((error) => {});
      // 这里可以调用后端API发送验证码
      // 使用setInterval实现倒计时
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          } else {
            clearInterval(interval);
            setSendButtonDisabled(false); // 倒计时结束，启用按钮
            return 0;
          }
        });
      }, 1000);
    } catch (error) {
      console.error("手机号验证失败", error);
    }
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };
  const passwordRules = [
    { required: true, message: "请输入密码" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || typeof value !== "string") {
          return Promise.resolve();
        }
        if (value.length < 6 || value.length > 16) {
          return Promise.reject("密码长度应为6-16位");
        }
        if (/[\u4e00-\u9fa5]/.test(value)) {
          return Promise.reject("密码不能包含中文");
        }
        return Promise.resolve();
      },
    }),
  ];
  return (
    <Form
      form={form}
      name="login"
      onFinish={handleFinish}
      autoComplete="off"
      {...formItemLayout}
    >
      <h2>登录</h2>
      <Form.Item
        name="username"
        label="手机号"
        rules={[
          { required: true, message: "请输入手机号" },
          {
            pattern: /^\d{11}$/,
            message: "请输入11位数字的手机号",
          },
        ]}
      >
        <Input placeholder="输入手机号" />
      </Form.Item>
      {logonType == 1 ? (
        <Form.Item
          name="phoneCode"
          label="验证码"
          rules={[{ required: true, message: "请输入验证码" }]}
        >
          <Space size={30}>
            <Input placeholder="请输入验证码" />
            <Button
              type="primary"
              onClick={handleGetCode}
              disabled={sendButtonDisabled}
              className="yam"
            >
              {countdown === 0 ? "获取验证码" : `${countdown}s`}
            </Button>
          </Space>
        </Form.Item>
      ) : (
        <Form.Item name="password" label="密码" rules={passwordRules}>
          <Input.Password placeholder="输入登录密码" />
        </Form.Item>
      )}
      {logonType == 2 ? (
        <div className="forgetPass">
          <Link to="/forgotpassword" className="forgot-password-link">
            忘记密码
          </Link>
        </div>
      ) : null}
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <div className="agreement-section">
          <Checkbox
            checked={agreeToTerms}
            onChange={(e) => setAgreeToTerms(e.target.checked)}
          >
            我已阅读并同意
          </Checkbox>
          <a
            href="/agreements/terms.html"
            target="_blank"
            className="agreement-link"
          >
            《用户协议》
          </a>
          和
          <a
            href="/agreements/privacy.html"
            target="_blank"
            className="agreement-link"
          >
            《隐私政策》
          </a>
        </div>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <Button type="primary" htmlType="submit" className="login_btn">
          登录
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Logon;
